/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClassroomUtilizationRow } from './ClassroomUtilizationRow';
import {
    ClassroomUtilizationRowFromJSON,
    ClassroomUtilizationRowFromJSONTyped,
    ClassroomUtilizationRowToJSON,
    ClassroomUtilizationRowToJSONTyped,
} from './ClassroomUtilizationRow';

/**
 * 
 * @export
 * @interface ClassroomUtilizationWidgetData
 */
export interface ClassroomUtilizationWidgetData {
    /**
     * 
     * @type {Array<ClassroomUtilizationRow>}
     * @memberof ClassroomUtilizationWidgetData
     */
    items: Array<ClassroomUtilizationRow>;
}

/**
 * Check if a given object implements the ClassroomUtilizationWidgetData interface.
 */
export function instanceOfClassroomUtilizationWidgetData(value: object): value is ClassroomUtilizationWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ClassroomUtilizationWidgetDataFromJSON(json: any): ClassroomUtilizationWidgetData {
    return ClassroomUtilizationWidgetDataFromJSONTyped(json, false);
}

export function ClassroomUtilizationWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassroomUtilizationWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ClassroomUtilizationRowFromJSON)),
    };
}

export function ClassroomUtilizationWidgetDataToJSON(json: any): ClassroomUtilizationWidgetData {
    return ClassroomUtilizationWidgetDataToJSONTyped(json, false);
}

export function ClassroomUtilizationWidgetDataToJSONTyped(value?: ClassroomUtilizationWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ClassroomUtilizationRowToJSON)),
    };
}

